/**
 * @generated SignedSource<<696c35a0883f968dc3d919f8f20ae002>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppQuery$variables = Record<PropertyKey, never>;
export type AppQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"App_user" | "GoogleAnalyticsInitialiser_data" | "Header_header" | "IntercomBooter_data">;
};
export type AppQuery = {
  response: AppQuery$data;
  variables: AppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerID",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userID",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleID",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "intercomUserHash",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "Header_header"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "IntercomBooter_data"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "App_user"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "GoogleAnalyticsInitialiser_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdmin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "impersonator",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Permissions",
            "kind": "LinkedField",
            "name": "permissions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allow",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deny",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Customer",
            "kind": "LinkedField",
            "name": "customer",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "preferences",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserPreferencesUserJourneyGroup",
                "kind": "LinkedField",
                "name": "userJourneyGroups",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "groupID",
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hidden",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ujIDs",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerToImpersonate",
            "kind": "LinkedField",
            "name": "possibleImpersonations",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerName",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserJourney",
        "kind": "LinkedField",
        "name": "userJourneys",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ujID",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "platformType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Customer",
            "kind": "LinkedField",
            "name": "customer",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "impersonatorUser",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v0/*: any*/),
          (v7/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Customer",
            "kind": "LinkedField",
            "name": "customer",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "environment",
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6c42a1a44cd05ad210793e520585c33a",
    "id": null,
    "metadata": {},
    "name": "AppQuery",
    "operationKind": "query",
    "text": "query AppQuery {\n  ...Header_header\n  ...IntercomBooter_data\n  ...App_user\n  ...GoogleAnalyticsInitialiser_data\n}\n\nfragment App_user on Query {\n  currentUser {\n    id\n  }\n}\n\nfragment DropdownMenus_UJPageMenu on User {\n  isAdmin\n}\n\nfragment GoogleAnalyticsInitialiser_data on Query {\n  currentUser {\n    isAdmin\n    impersonator\n    customer {\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment Header_PossibleImpersonations on User {\n  possibleImpersonations {\n    customerID\n    customerName\n    userID\n    roleID\n  }\n}\n\nfragment Header_SelectedUJCustomerName on UserJourney {\n  ujID\n  customer {\n    name\n    id\n  }\n}\n\nfragment Header_SelectedUJToolkit on UserJourney {\n  ujID\n  name\n}\n\nfragment Header_header on Query {\n  ...Header_navigation\n}\n\nfragment Header_navigation on Query {\n  currentUser {\n    isAdmin\n    impersonator\n    permissions {\n      allow\n      deny\n    }\n    ...Header_user\n    ...UJMenu_user\n    ...DropdownMenus_UJPageMenu\n    ...Header_PossibleImpersonations\n    id\n  }\n  userJourneys {\n    ujID\n    ...UJMenu_UJs\n    ...Header_SelectedUJToolkit\n    ...Header_SelectedUJCustomerName\n    id\n  }\n}\n\nfragment Header_user on User {\n  displayName\n  customer {\n    name\n    id\n  }\n  permissions {\n    allow\n    deny\n  }\n}\n\nfragment IntercomBooter_data on Query {\n  currentUser {\n    login\n    displayName\n    email\n    userID\n    roleID\n    intercomUserHash\n    customer {\n      customerID\n      name\n      id\n    }\n    id\n  }\n  impersonatorUser {\n    login\n    displayName\n    email\n    userID\n    roleID\n    intercomUserHash\n    customer {\n      customerID\n      name\n      id\n    }\n    id\n  }\n  environment\n}\n\nfragment UJMenu_UJs on UserJourney {\n  ujID\n  name\n  platformType\n  customer {\n    name\n    id\n  }\n}\n\nfragment UJMenu_user on User {\n  permissions {\n    allow\n    deny\n  }\n  ...userJourneys_userPreferences\n}\n\nfragment userJourneys_userPreferences on User {\n  preferences {\n    userJourneyGroups {\n      groupID\n      name\n      hidden\n      ujIDs\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ab6af2ec08e62445ebf6b64df95093a";

export default node;
